import { AdminAllowanceNames } from '@pharmaplan/common';

import strings from '../../../localization';

export const config = (isSelfService:boolean) =>
  (isSelfService
    ? [
      {
        key: '1',
        name: AdminAllowanceNames.pharmacistHourlyRate,
        label: strings.pharmacistHourlyRate,
      },
    ]
    : [
      {
        key: '1',
        name: AdminAllowanceNames.pharmacistHourlyRate,
        label: strings.pharmacistHourlyRate,
      },
      {
        key: '2',
        name: AdminAllowanceNames.pharmacyHourlyRate,
        label: strings.pharmacyHourlyRate,
      },

    ]);
